import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import { MalaPuscicaDesno, MalaPuscicaLevo } from 'kzv-icons';

const HorizontalScroller = ({ children }: { children: ReactNode }) => {
    const [showLeftScrollArrow, setShowLeftScrollArrow] = useState(false);
    const [showRightScrollArrow, setShowRightScrollArrow] = useState(false);
    const [scrollableContainer, setScrollableContainer] = useState(null);
    const scrollContainer = (direction) => {
        scrollableContainer.scrollBy({ left: direction === 'right' ? 350 : -350, behavior: 'smooth' });
    };

    const onContainerScroll = (e) => {
        const scrollValue = e.target.scrollLeft;
        if (scrollValue > 0 && !showLeftScrollArrow) {
            setShowLeftScrollArrow(true);
        } else if (scrollValue === 0) {
            setShowLeftScrollArrow(false);
        }

        if (scrollValue + scrollableContainer.offsetWidth === scrollableContainer.scrollWidth) {
            setShowRightScrollArrow(false);
        } else if (scrollableContainer.scrollWidth > scrollableContainer.offsetWidth) {
            setShowRightScrollArrow(true);
        }
    };

    const onRefChange = useCallback((container) => {
        setScrollableContainer(container);
        if (container !== null) {
            if (container.scrollWidth > container.offsetWidth) {
                setShowRightScrollArrow(true);
            }
        }
    }, []);

    const onResize = () => {
        if (scrollableContainer.scrollWidth > scrollableContainer.offsetWidth) {
            setShowRightScrollArrow(true);
        } else {
            setShowRightScrollArrow(false);
        }
    };

    useEffect(() => {
        if (scrollableContainer) {
            window.addEventListener('resize', onResize);
        }
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, [scrollableContainer]);

    const arrowStyles =
        'absolute px-2 h-full z-10 transition cursor-pointer hover:text-brand outline-none focus:ring-0 focus:outline-none';

    return (
        <div className="relative">
            <button
                onClick={() => scrollContainer('left')}
                className={`left-0 white-gradient-left ${arrowStyles} ${showLeftScrollArrow ? '' : 'invisible'}`}
            >
                <MalaPuscicaLevo strokeWidth={2.5} />
            </button>
            <button
                onClick={() => scrollContainer('right')}
                className={`right-0 white-gradient-right ${arrowStyles} ${showRightScrollArrow ? '' : 'invisible'}`}
            >
                <MalaPuscicaDesno strokeWidth={2.5} />
            </button>
            <div
                className="w-full overflow-x-auto overflow-y-hidden whitespace-nowrap hide-scrollbars relative pr-4"
                onScroll={onContainerScroll}
                ref={onRefChange}
            >
                {children}
            </div>
        </div>
    );
};

export default HorizontalScroller;
